import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_ROOT = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_ROOT,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("edil_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve a stored image URL ("/api/files/..") to an absolute URL
export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatPrice = (n) => {
  if (n == null || n === "") return "Trattativa riservata";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
};
